import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_MODAL_QUESTION,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ORDER,
  SET_ORDERBY,
  GET_LIST_ALL_QUESTIONS_SUCCESS,
  SEARCH,
  SET_LOADING_SEND,
  GET_BY_ID_SUCCESS
} from './client-checklist-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSend: false,
  loadingModalQuestion: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'desc',
    orderBy: 'updatedAt'
  },
  modalData: {
    questions: []
  }
};

const clientChecklist = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case SET_LOADING_MODAL_QUESTION: {
      return {
        ...state,
        loadingModalQuestion: action.loading
      };
    }

    case GET_LIST_ALL_QUESTIONS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.checklist,
          allRows: action.payload?.checklist,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.userExternalCode?.toString().startsWith(queryString.toLowerCase()) ||
                item?.userExternalCode?.includes(queryString) ||
                item?.questionaryName?.toString().startsWith(queryString.toLowerCase()) ||
                item?.questionaryName?.includes(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default clientChecklist;
